import { render, staticRenderFns } from "./Electricity.vue?vue&type=template&id=16609a08&scoped=true&"
import script from "./Electricity.vue?vue&type=script&lang=js&"
export * from "./Electricity.vue?vue&type=script&lang=js&"
import style0 from "./Electricity.vue?vue&type=style&index=0&id=16609a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16609a08",
  null
  
)

export default component.exports